import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fixed-teeth',
  templateUrl: './fixed-teeth.component.html',
  styleUrls: ['./fixed-teeth.component.scss']
})
export class FixedTeethComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
